import axios from "axios";
import { InteractionRequiredAuthError } from "msal";
import { authProvider } from "../authProvider";
import ResultResponseModelOutput from "../models/ResultResponseModelOutput";
const {
    ACTIVE_DIRECTORY_APP_CLIENT_ID
  } = process.env;

export const refreshAccessToken = async () => {
  const user = authProvider.getAccountInfo();
  
  try {
    const token = await authProvider.acquireTokenSilent({
      scopes: ["openid", "profile", "User.Read"],
    });

    return token.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const tokenInteractionRequiredAuthError = authProvider
      .acquireTokenPopup({
        scopes: ["openid", "profile", "User.Read"]
      })
      .then((resp) => {
        return resp.accessToken;
      })
      .catch((err) => {
        return sessionStorage.getItem(`msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`);
      });

      return tokenInteractionRequiredAuthError;
    } else {
      console.error('error2', error);
      return sessionStorage.getItem(`msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`);
    }
  }
};

const ID_TOKEN_CACHE_KEY = `msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`;
// MSAL renews the id token with OIDC scopes only; asking for "User.Read" here
// requests a Graph access token the app never uses.
const ID_TOKEN_SCOPES = ["openid", "profile"];
// Same offset MSAL uses (tokenRenewalOffsetSeconds): renew once <5 min remain.
const RENEW_BEFORE_EXPIRY_MS = 5 * 60 * 1000;

interface ResolveIdTokenDeps {
  acquireTokenSilent: (request: { scopes: string[] }) => Promise<any>;
  login: () => void;
  getCachedToken: () => string | null;
  now?: number;
}

/** Expiration of a JWT in epoch milliseconds, or null when it cannot be read. */
export const getTokenExpiration = (jwt: string): number | null => {
  try {
    const payload = jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(payload));
    return typeof exp === "number" ? exp * 1000 : null;
  } catch (e) {
    return null;
  }
};

const isTokenValid = (jwt: string | null, now: number, marginMs: number): jwt is string => {
  if (!jwt) return false;
  const exp = getTokenExpiration(jwt);
  return exp !== null && exp - now > marginMs;
};

export const getCachedIdToken = (): string | null =>
  sessionStorage.getItem(ID_TOKEN_CACHE_KEY) ||
  authProvider.getAccountInfo()?.jwtIdToken ||
  null;

/**
 * Returns the id token to send as Bearer.
 *
 * The token already in the MSAL cache is used as long as it is fresh. A silent
 * renewal is only attempted when it is about to expire. That renewal runs in a
 * hidden iframe against login.microsoftonline.com and needs a third-party cookie,
 * which Safari and every browser on iPadOS block (ITP). There it rejects with
 * "interaction_required" even for a signed-in user, so a failed renewal must not
 * block the request while the cached token is still valid. Only when nothing
 * usable is left do we fall back to a full-page login redirect, which works in
 * every browser.
 */
export const resolveIdToken = async ({
  acquireTokenSilent,
  login,
  getCachedToken,
  now = Date.now(),
}: ResolveIdTokenDeps): Promise<string> => {
  const cached = getCachedToken();
  if (isTokenValid(cached, now, RENEW_BEFORE_EXPIRY_MS)) {
    return cached;
  }

  try {
    const response = await acquireTokenSilent({ scopes: ID_TOKEN_SCOPES });
    const renewed = response?.idToken?.rawIdToken || getCachedToken();
    if (renewed) return renewed;
    throw new Error("Silent token renewal returned no id token");
  } catch (error) {
    const fallback = getCachedToken();
    if (isTokenValid(fallback, now, 0)) {
      return fallback;
    }
    login();
    throw error;
  }
};

export const setHeaderBearerToken = async () => {
  axios.interceptors.request.use(async (config) => {
    const idToken = await resolveIdToken({
      acquireTokenSilent: (request) => authProvider.acquireTokenSilent(request),
      login: () => authProvider.login(),
      getCachedToken: getCachedIdToken,
    });

    config.headers = {
      ...config.headers,
      'Authorization': `Bearer ${idToken}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }

    return config;
  }, (error) => Promise.reject(error));
};

//TODO: IMPLEMENTAR REFRESH TOKEN
export const setHeaderBearerRefreshToken = async ({
}) => {
    axios.interceptors.response.use((response) => {
        return response
      }, async function (error) {
        const originalRequest = error.config;
        if (error.response.status === 403 && !originalRequest._retry) {
          originalRequest._retry = true;
          const access_token = await refreshAccessToken();
          axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
          return axios(originalRequest);
        }
        return Promise.reject(error);
      });
};

// const refreshAccessToken = async () => {
//   const user = authProvider.getAccountInfo();
//   try {
//     const token = await authProvider.acquireTokenSilent({
//       // scopes: loginRequest.scopes,
//       account: user?.account,
//     });
//     return token.accessToken;
//   } catch (error) {
//     if (error instanceof InteractionRequiredAuthError) {
//       // return authProvider
//       //   .acquireTokenPopup(loginRequest)
//       //   .then((resp) => {
//       //     return resp.accessToken;
//       //   })
//       //   .catch((err) => {
//       //     return null;
//       //   });
//     } else {
//       console.error(error);
//     }
//   }
// };

export const useInterceptor = () => {    
    let resultResponseModelOutput = new ResultResponseModelOutput();
    resultResponseModelOutput.invalid = false;
    resultResponseModelOutput.message = "";
    resultResponseModelOutput.type = "error";
        
    // axios.interceptors.response.use(function (response) {        
    //         return response;
    //     }, function (error) {   
    //             clearResultResponseModelOutput();                
    //             let responseStatus  = JSON.parse(JSON.stringify(error.response)); 
    //             let formatMessage = responseStatus.data.errors.join(" <br /> ");
    //             let statusCode = error.response.status;                
    //             switch(statusCode) {
    //                 case 400:
    //                     resultResponseModelOutput = new ResultResponseModelOutput();
    //                     resultResponseModelOutput.invalid = true;
    //                     resultResponseModelOutput.message = formatMessage;
    //                     resultResponseModelOutput.type = "info";
    //                     setResultRequestOutput(resultResponseModelOutput);  
    //                     break;
    //                 case 401:
    //                     //TODO: redirect to login ou refresh token
    //                 break;
    //                 case 500:
    //                     resultResponseModelOutput = new ResultResponseModelOutput();
    //                     resultResponseModelOutput.invalid = true;
    //                     resultResponseModelOutput.message = formatMessage;
    //                     resultResponseModelOutput.type = "error";
    //                     setResultRequestOutput(resultResponseModelOutput);
    //                 break;
    //             }                
    //     });
        
    //     const clearResultResponseModelOutput = () => {
    //         resultResponseModelOutput = new ResultResponseModelOutput();
    //         resultResponseModelOutput.invalid = false;
    //         resultResponseModelOutput.message = "";
    //         resultResponseModelOutput.type = "error";
    //         setResultRequestOutput(resultResponseModelOutput);    
    //       };

    return {               
    };
}

